export default "__VITE_ASSET__63dc7422__"